function SSDocumentSlider(options) {
  this._init(options);
}

SSDocumentSlider.prototype._initInner = function() {
  this.inner = this.container.find('.slidesContainer');
};

SSDocumentSlider.prototype._init = function(options) {
  
  this.MIN_THUMB_HEIGHT = this.MIN_THUMB_WIDTH = 30;
  this.X_SCROLLBAR_HEIGHT = this.Y_SCROLLBAR_WIDTH = 10;
  this.dDisplayer = options.dDisplayer;
  this.container = this.dDisplayer.container;
  this.isMobile = typeof(config) !== "undefined" && window.config.hosted_in === "mobile_slideview";
  
  this.container.addClass('documentSliderEnabled');

  this.viewHeight = this.container.height();
  this.viewWidth = this.container.width();
  
  if(!this.isMobile){
    this.keypressHandlerBound = false;
    this.bindKeypressHandler();
    this.bindWheelHandler();
  }
  this.initScrollbars();
};

SSDocumentSlider.prototype.initScrollbars = function() {
  // We need to adjust for the width of the Y scrollbar when drawing the X scrollbar,
  // and vice versa, so that the X and Y scrollbar tracks don't overlap.
  var styles = {
    X : {
      width: this.container.width() - this.Y_SCROLLBAR_WIDTH,
      bottom: $('.toolbar').height() + 8
    },
    Y: {
      height: this.container.height() - this.X_SCROLLBAR_HEIGHT,
      top: $('.actions').height() + 1
    }
  };

  this.scrollbarX = $('<div id="docscroller-bar-x" class="docscroller-bar">&nbsp;</div>');
  this.scrollbarY = $('<div id="docscroller-bar-y" class="docscroller-bar">&nbsp;</div>');

  this.scrollbarX.css(styles.X);
  this.scrollbarY.css(styles.Y);

  $('.playerWrapper').append(this.scrollbarX);
  $('.playerWrapper').append(this.scrollbarY);
};

SSDocumentSlider.prototype.drawThumbs = function() {
  var totalWidth = $('.slidesContainer').width();
  var totalHeight = $('.slidesContainer').height();

  // prevent divide by zero
  if (totalWidth === 0 || totalHeight === 0) {
    return;
  }

  // The thumb should be as wide/high relative to its scrollbar
  // as the viewport is wide/high relative to the overall document.
  var thumbWidth = Math.ceil(this.viewWidth * this.scrollbarX.width() / totalWidth);
  var thumbHeight = Math.ceil(this.viewHeight * this.scrollbarY.height() / totalHeight);

  thumbWidth = Math.max(this.MIN_THUMB_WIDTH, thumbWidth);
  thumbHeight = Math.max(this.MIN_THUMB_HEIGHT, thumbHeight);

  if (!this.thumbX) {
    this.thumbX = $('<div id="docscroller-thumb-x" class="docscroller-thumb">&nbsp;</div>');
    this.scrollbarX.append(this.thumbX);
  }

  if (!this.thumbY) {
    this.thumbY = $('<div id="docscroller-thumb-y" class="docscroller-thumb">&nbsp;</div>');
    this.scrollbarY.append(this.thumbY);
  }

  this.thumbXTravelLength = this.scrollbarX.width() - thumbWidth;
  this.thumbYTravelLength = this.scrollbarY.height() - thumbHeight;

  this.scrollbarX.css('display', this.thumbXTravelLength ? 'block' : 'none');
  this.thumbX.css('display', this.thumbXTravelLength ? 'block' : 'none');
  this.thumbX.css('width', thumbWidth);
  this.thumbY.css('height', thumbHeight);
};

SSDocumentSlider.prototype.updateInnerFromThumbX = function() {
  // What proportion of the thumb's overall travel has it travelled?
  var xProportion = parseInt(this.thumbX.css('left'), 10) / this.thumbXTravelLength ;
  var newInnerX = (this.viewWidth - this.inner.width()) * xProportion;

  this.inner.css('left', newInnerX);
};

SSDocumentSlider.prototype.updateInnerFromThumbY = function() {
  // What proportion of the thumb's overall travel has it travelled?
  var yProportion = parseInt(this.thumbY.css('top'), 10) / this.thumbYTravelLength ;
  var newInnerY = (this.viewHeight - this.inner.height()) * yProportion;

  this.inner.css('top', newInnerY);
  this._postScroll();
};

SSDocumentSlider.prototype.makeScrollbarsClickable = function() {
  var that = this;

  this.scrollbarX.click(function(e) {
    var newThumbX = e.pageX - $(this).offset().left;

    newThumbX = Math.max(0, Math.min(newThumbX, that.thumbXTravelLength));
    that.thumbX.css('left', newThumbX);

    that.updateInnerFromThumbX();
  });

  this.scrollbarY.click(function(e) {
    var newThumbY = e.pageY - $(this).offset().top;

    newThumbY = Math.max(0, Math.min(newThumbY, that.thumbYTravelLength));
    that.thumbY.css('top', newThumbY);

    that.updateInnerFromThumbY();
  });
};

SSDocumentSlider.prototype.makeThumbsDraggable = function() {
  var that = this;

  // Required for compatibility with makeScrollbarsClickable handlers
  this.thumbX.click(function(e) {
    e.stopPropagation();
  });

  this.thumbY.click(function(e) {
    e.stopPropagation();
  });

  this.thumbX.mousedown(function(e) {
    $(this).addClass('active');
    var clickOffset = e.pageX;
    var initialX = parseInt(that.thumbX.css('left'), 10);

    if (!that.inner) {
      that._initInner();
    }

    $(window).mousemove(function(emove) {
      emove.preventDefault();

      that._clearSelection();

      var newThumbX = (initialX + emove.screenX - e.screenX);
      // ensure 0 < newThumbX < thumbTravelLength
      newThumbX = Math.max(0, Math.min(newThumbX, that.thumbXTravelLength));
      that.thumbX.css('left', newThumbX);

      that.updateInnerFromThumbX();

    }).one('mouseup', function() {
      that.thumbX.removeClass('active');
      $(window).unbind('mousemove');
    });
  });

  this.thumbY.mousedown(function(e) {
    $(this).addClass('active');
    var clickOffset = e.pageY;
    var initialY = parseInt(that.thumbY.css('top'), 10);

    if (!that.inner) {
      that._initInner();
    }

    $(window).mousemove(function(emove) {
      emove.preventDefault();

      that._clearSelection();

      var newThumbY = (initialY + emove.screenY - e.screenY);
      // ensure 0 < newThumbY < thumbTravelLength
      newThumbY = Math.max(0, Math.min(newThumbY, that.thumbYTravelLength));
      that.thumbY.css('top', newThumbY);

      that.updateInnerFromThumbY();

    }).one('mouseup', function() {
      that.thumbY.removeClass('active');
      $(window).unbind('mousemove');
    });
  });
};

SSDocumentSlider.prototype.scrollHandler = function(deltaX, deltaY) {
  if (!this.inner) {
    this._initInner();
  }

  var X = parseInt(this.inner.css('left'), 10);
  var Y = parseInt(this.inner.css('top'), 10);

  var wiggleX = this.container.width() - this.inner.width();

  var newX = Math.min(0, X + deltaX);
  var newY = Math.min(0, Y + deltaY);

  newX = Math.max(wiggleX, newX);
  newY = Math.max(newY, this.viewHeight - this.inner.height());

  this.inner.css({
    left: newX,
    top: newY
  });

  if (this.thumbX) {
    var thumbXPosition = (this.thumbX.width() - this.scrollbarX.width()) * newX / (this.inner.width() - this.viewWidth);
    this.thumbX.css('left', thumbXPosition);
  }

  if (this.thumbY) {
    var thumbYPosition = (this.thumbY.height() - this.scrollbarY.height()) * newY / (this.inner.height() - this.viewHeight);
    this.thumbY.css('top', thumbYPosition);
  }

  var currentSlide = this.dDisplayer.detectCurrentSlide();
  $.slideshareEventManager.trigger('slidescrolled', {
    index : currentSlide,
    alreadyInPosition: true
  });
};

SSDocumentSlider.prototype._clearSelection = function() {
  if (typeof window.getSelection().empty === 'function') {
    window.getSelection().empty();
  } else if (typeof window.getSelection.collapseToStart === 'function') {
    window.getSelection().collapseToEnd();
  }
};

SSDocumentSlider.prototype.topEdge = function() {
  return Math.abs(parseInt(this.inner.css('top'), 10));
};

SSDocumentSlider.prototype.bindKeypressHandler = function() {
  var that = this;
  $('.playerWrapper').on('click', function(e) {
    e.stopImmediatePropagation();

    if (!that.keypressHandlerBound) {
      that.keypressHandlerBound = true;

      $(document).on('keydown', function(e) {
        var keymap = [];
        keymap[38] = 'up'; // up arrow
        keymap[40] = 'down'; // down arrow
        keymap[37] = 'left'; // left arrow
        keymap[39] = 'right'; // right arrow
        keymap[33] = 'up'; // page up
        keymap[34] = 'down'; // page down

        if (keymap[e.keyCode]) {
          e.preventDefault();
          switch (keymap[e.keyCode]) {
            case 'up':
              that.scrollHandler(0, 100);
              break;
            case 'down':
              that.scrollHandler(0, -100);
              break;
            case 'left':
              that.scrollHandler(100, 0);
              break;
            case 'right':
              that.scrollHandler(-100, 0);
              break;
            default:
              break;
          }
        }
      });

      $('body').one('click', function(e) {
        that.keypressHandlerBound = false;
        $(document).off('keydown');
      });
    }
  });
};

SSDocumentSlider.prototype.bindWheelHandler = function() {
  var that = this;
  this.wheelEventName = 'DOMMouseScroll'; // This is what FF pre 17 uses

  if (typeof document.onmousewheel === 'object') {
    // This is what the mousewheel plugin gives us
    this.wheelEventName = 'mousewheel'; // Webkit
  } else {
    try {
      // This is the standard. IE10+, FF17+
      var testWheelEvent = new WheelEvent('wheel');
      this.wheelEventName = 'wheel';
    } catch (e) {
    }
  }

  // Add a namespace to the event name.
  // Then, make a note of the namespaced event name, so that we can unbind it later.

  this.wheelEventName += '.SSDocumentSlider';

  this.container.bind(this.wheelEventName, function(e) {
    e.preventDefault();

    if (!that.wheelXDimension || !that.wheelYDimension) {
      if (e.originalEvent.wheelDeltaX || e.originalEvent.wheelDeltaY) { // WEBKIT
        that.wheelXDimension = function(event) {
          return event.originalEvent.wheelDeltaX;
        };
        that.wheelYDimension = function(event) {
          return event.originalEvent.wheelDeltaY;
        };
      } else if (e.originalEvent.deltaX || e.originalEvent.deltaY) { // FF NEW
        that.wheelXDimension = function(event) {
          return -event.originalEvent.deltaX;
        };
        that.wheelYDimension = function(event) {
          return -event.originalEvent.deltaY;
        };
      } else if (e.originalEvent.axis) { // FF OLD
        that.wheelXDimension = function(event) {
          return (event.originalEvent.axis === 1) ? -10 * event.originalEvent.detail : 0;
        };
        that.wheelYDimension = function(event) {
          return (event.originalEvent.axis === 2) ? -10 * event.originalEvent.detail : 0;
        };
      } else if (e.originalEvent.wheelDelta) { // IE
        that.wheelXDimension = function(event) {
          return (Math.abs(event.originalEvent.wheelDelta) >= 840) ? event.originalEvent.wheelDelta : 0;
        };
        that.wheelYDimension = function(event) {
          return (Math.abs(event.originalEvent.wheelDelta) < 840) ? event.originalEvent.wheelDelta : 0;
        };
      }
    }

    that.scrollHandler.call(that, that.wheelXDimension(e), that.wheelYDimension(e));
  });
};

SSDocumentSlider.prototype._postScroll = function() {
  $.slideshareEventManager.trigger('slidescrolled', {
    index : this.dDisplayer.detectCurrentSlide(),
    alreadyInPosition: true
  });
};

SSDocumentSlider.prototype.cleanup = function() {
  this.scrollbarX.remove();
  this.scrollbarY.remove();
  this.container.removeClass('documentSliderEnabled');

  // unbind keypress handler
  $('.playerWrapper').off('click');

  this.container.unbind(this.wheelEventName);
};
